export default {
  allowMediaInserter: false,
  anchorEditor: false,
  anchorPreview: false,
  attributeInserter: true,
  textFormatter: false,
  allowMention: false,
  allowAlignment: false,
  allowAttribute: true,
  allowBold: false,
  allowItalic: false,
  allowAnchor: false,
  allowHeading: false,
  allowSubheading: false,
  allowOrderedList: false,
  allowUnorderedList: false,
  allowImage: false,
  allowButton: false,
  allowVideo: false,
  allowSocial: false,
  allowCode: false,
  allowHtml: false,
  allowAttachments: false,
  allowEmoji: true,
  removeLineBreaks: true,
  readOnly: false,
  displaySocialBlocksAsButtons: false,
  urlReplacement: false,
  // Perform automatic conversion of URLs to anchors
  markdownLinks: false,
  // Convert markdown links to anchors
  markdownInlineCode: false,
  autoFocusTopLeft: false,
  recoverErrors: false,
  allowRtl: false,
  singleBlock: true
};